export default function map(nodes, transform, level = 0) {
  return nodes.map((node, i) => {
    const newNode = transform(node, i, level)
    return newNode.set('children', map(newNode.get('children'), transform, level + 1))
  })
}
